import React from 'react';

import classnames from 'classnames';


import './styles.scss';

const PrimaryButton = ({ type, onClick, children, disabled, fullWidth = false }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classnames({ primary: true, 'full-width': fullWidth })}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
